import Button from '@mui/material/Button';
import useGlobalStyles from '../../useGlobalStyles';
import useAskQuestionButton from '../../../hooks/useAskQuestionButton';

/**
 * AskQuestionButton component that renders a button for navigating to the
 * "New Question" page. When clicked, it redirects the user to the page
 * where they can ask a new question.
 */
const AskQuestionButton = () => {
  const { classes: globalClasses } = useGlobalStyles();

  const { handleNewQuestion } = useAskQuestionButton();

  return (
    <Button
      className={globalClasses.button}
      onClick={() => {
        setTimeout(() => {
          handleNewQuestion();
        }, 200);
      }}>
      Ask a Question
    </Button>
  );
};

export default AskQuestionButton;
